/**
 * PageLoading — Variantes de skeleton para páginas inteiras
 */
import { SkeletonBar } from './SkeletonBar';
import { TableSkeleton } from './TableSkeleton';
import { T } from '../../styles/tokens';

interface PageLoadingProps {
  variant?: 'default' | 'profile' | 'dashboard';
  rows?: number;
}

export function PageLoading({ variant = 'default', rows = 3 }: PageLoadingProps) {
  if (variant === 'profile') {
    return (
      <div style={{ padding: T.space6 }}>
        <div style={{ display: 'flex', gap: T.space4, alignItems: 'center', marginBottom: T.space6 }}>
          <SkeletonBar width={64} height={64} style={{ borderRadius: '50%' }} />
          <div style={{ flex: 1 }}>
            <SkeletonBar width="40%" height={16} style={{ marginBottom: T.space2 }} />
            <SkeletonBar width="25%" height={12} />
          </div>
        </div>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} style={{ marginBottom: T.space4 }}>
            <SkeletonBar width="20%" height={10} style={{ marginBottom: 6 }} />
            <SkeletonBar width="100%" height={36} style={{ borderRadius: T.radiusMd }} />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'dashboard') {
    return (
      <div style={{ padding: T.space6 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: T.space3, marginBottom: T.space6 }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} style={{ border: `1px solid ${T.border}`, borderRadius: T.radiusLg, padding: T.space5, background: T.bgCard }}>
              <SkeletonBar width="50%" height={10} style={{ marginBottom: T.space3 }} />
              <SkeletonBar width="60%" height={24} />
            </div>
          ))}
        </div>
        <TableSkeleton rows={5} cols={4} />
      </div>
    );
  }

  return (
    <div style={{ padding: T.space6 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ marginBottom: T.space5 }}>
          <SkeletonBar width={`${40 + (i % 3) * 20}%`} height={14} style={{ marginBottom: T.space2 }} />
          <SkeletonBar width={`${60 + (i % 2) * 25}%`} height={14} style={{ marginBottom: T.space2 }} />
          <SkeletonBar width={`${30 + (i % 3) * 15}%`} height={14} />
        </div>
      ))}
    </div>
  );
}
